import { useTranslation } from "react-i18next";

import type { SimpleHeaderProps } from "./SimpleHeader.decl";

export function HeaderSimple({ label }: SimpleHeaderProps) {
  const { t } = useTranslation();

  return <span className="text-tiny font-medium">{t(label)}</span>;
}
